import { styled } from '@mui/material';
import { DataGrid, DataGridProps, gridClasses } from '@mui/x-data-grid';

interface NewDataGridProps extends DataGridProps {
  disableCursorPointer?: boolean;
}

const AgaveDataGrid = styled((props: NewDataGridProps) => (
  <DataGrid
    {...props}
    {...defaultDataGridProps}
    rowHeight={props.rowHeight ?? defaultDataGridProps.rowHeight}
    localeText={{
      ...defaultDataGridProps.localeText,
      ...props.localeText,
      noRowsLabel:
        props.localeText?.noRowsLabel ??
        defaultDataGridProps.localeText?.noRowsLabel ??
        'No hay información disponible',
      noResultsOverlayLabel:
        props.localeText?.noResultsOverlayLabel ??
        props.localeText?.noRowsLabel ??
        defaultDataGridProps.localeText?.noResultsOverlayLabel ??
        'No se encontraron resultados.',
    }}
  />
))<NewDataGridProps>(({ theme, disableCursorPointer }) => ({
  width: '100%',
  color: theme.palette.primary.main,
  fontSize: '1rem',
  border: 'none',
  // minWidth: '800px',
  borderColor: 'transparent',
  '& .MuiDataGrid-columnSeparator--resizable': {
    color: 'transparent',
  },
  '& .MuiDataGrid-topContainer div': {
    border: 'none',
    backgroundColor: '#f0f8e8',
  },
  '& .MuiDataGrid-virtualScroller': {
    overflow: 'visible !important',
  },
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    height: '100%',
  },
  '& .MuiDataGrid-row': {
    // userSelect: 'none',
    //   borderRadius: 8,
    cursor: disableCursorPointer ? 'default' : 'pointer',
    width: 'calc(100% - 2px)',
    // borderBottom: '1px solid rgba(224, 224, 224, 1)',
    backgroundColor: theme.palette.common.white,
  },
  '& .MuiDataGrid-cell': {
    border: 'none',
    position: 'relative',
  },
  '& .MuiDataGrid-cell:not(:last-child):after': {
    right: 1,
    width: 1,
    zIndex: 2,
    content: "''",
    position: 'absolute',
    top: theme.spacing(1),
    bottom: theme.spacing(1),
  },
  '& .MuiDataGrid-footerContainer': {
    border: 'none',
    backgroundColor: '#f0f8e8',
    flexDirection: 'column  !important',
    justifyContent: 'center !important',
  },
  [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
    outline: 'none',
  },
  [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]: {
    outline: 'none',
  },
  [`& .${gridClasses.columnSeparator}`]: {
    [`&:not(.${gridClasses['columnSeparator--resizable']})`]: {
      display: 'none',
    },
  },
}));

const defaultDataGridProps: Partial<DataGridProps> = {
  rowHeight: 90,
  columnHeaderHeight: 80,
  pageSizeOptions: [10, 25, 50, 75, 100],
  localeText: {
    noRowsLabel: 'No hay información disponible',
    noResultsOverlayLabel: 'No se encontraron resultados.',
  },
  slots: {
    // pagination: AgavePagination,
  },

  slotProps: {
    pagination: {
      labelRowsPerPage: 'Elementos por página',
      labelDisplayedRows: ({
        from,
        to,
        count,
      }: {
        from: string | number;
        to: string | number;
        count: number;
      }) => `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
    },
  },
};

export { AgaveDataGrid };
